export const COUNT_OPEN_CHAT_CONVERSATIONS_SUCCESS = 'COUNT_OPEN_CHAT_CONVERSATIONS_SUCCESS';

export const countOpenChatConversationsSuccess = ({ count, request }) => ({
    type: COUNT_OPEN_CHAT_CONVERSATIONS_SUCCESS,
    payload: { count },
    meta: {
        request,
    }
});
